import { Component, OnInit } from '@angular/core';
import { environment } from 'apps/cinema1/src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-voucher-voucher-details-component',
  templateUrl: './voucher-details.component.html',
  styleUrls: ['./voucher-details.component.scss']
})
export class CustomVoucherDetailsComponent implements OnInit {
  public env: any = {};

  public constructor() {
    this.env = environment;
  }

  public ngOnInit(): void {}
}
